import React, {useEffect, useState} from "react";
import {NavLink} from "react-router-dom";
import {
  Icon,
  isProfileOpportunityTypeTags,
  isProfileRoleTypeTags, Tooltip,
  useAction,
  useObject,
  useProfile,
} from "@vokymlak/kabinet-ui";
import {
  OPPORTUNITY_HANDBOOK, OPPORTUNITY_KANBAN, OPPORTUNITY_REALIZATION,
  OPPORTUNITY_TICKETS,
  ROLE_ADMINISTRATOR,
  ROLE_CLIENT,
  ROLE_DIRECTOR, ROLE_DISPLAY,
  ROLE_EMPLOYEE,
} from "../../config/constants";
import {ROOT_URL} from "../../config/url";

function MenuRouting(props) {
  const {profile} = useProfile();

  const [isFullScreen, setIsFullScreen] = useState(false);
  useEffect(() => {
    updateFullScreen();
  }, []);

  const [isProfile, setIsProfile] = useState(true);

  const onChange = () => {
    if (!!props.onChange) {
      props.onChange()
    }
  }

  const onChangeFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    }

    setTimeout(() => updateFullScreen(), 500);
  };

  const updateFullScreen = () => {
    if (!document.fullscreenElement) {
      setIsFullScreen(false);
    } else if (document.exitFullscreen) {
      setIsFullScreen(true);
    }
  };

  return (
    <>
      {isProfileRoleTypeTags(profile, [
        ROLE_ADMINISTRATOR,
        ROLE_DIRECTOR,
        ROLE_EMPLOYEE,
      ]) && (
        <ul className="Menu__list Menu__list_box">
          {(isProfileRoleTypeTags(profile, [
            ROLE_ADMINISTRATOR,
            ROLE_DIRECTOR,
          ]) || isProfileOpportunityTypeTags(profile, [
            OPPORTUNITY_REALIZATION,
          ])) && (
            <li className="List__link">
              <NavLink className={"Link__text"} to={"/realization-orders"} onClick={() => onChange()}>
                Реализация
              </NavLink>
            </li>
          )}
          <li className="List__link">
            <NavLink className={"Link__text"} to={"/income-orders"} onClick={() => onChange()}>
              Поступление
            </NavLink>
          </li>
        </ul>
      )}

      {isProfileRoleTypeTags(profile, [
        ROLE_ADMINISTRATOR,
        ROLE_DIRECTOR,
        ROLE_EMPLOYEE,
      ]) && (
        <ul className="Menu__list Menu__list_box">
          <li className="List__link" style={{paddingTop: 12}}>
            <NavLink
              className={"Link__text"}
              to={"/production-orders"}
              onClick={() => onChange()}
            >
              Производство
            </NavLink>
          </li>
          <li className="List__link" style={{paddingTop: 12}}>
            <NavLink
              className={"Link__text"}
              to={"/boning-orders"}
              onClick={() => onChange()}
            >
              Обвалка
            </NavLink>
          </li>
        </ul>
      )}

      {isProfileRoleTypeTags(profile, [
        ROLE_ADMINISTRATOR,
        ROLE_DIRECTOR,
        ROLE_EMPLOYEE,
      ]) && (
        <ul className="Menu__list Menu__list_box">
          <li className="List__link">
            <NavLink className={"Link__text"} to={"/contractors"} onClick={() => onChange()}>
              Контрагенты
            </NavLink>
          </li>
        </ul>
      )}

      {isProfileRoleTypeTags(profile, [
        ROLE_ADMINISTRATOR,
        ROLE_DIRECTOR,
      ]) && (
          <ul className="Menu__list Menu__list_box">
            <li className="List__link">
              <NavLink className={"Link__text"} to={"/branches"} onClick={() => onChange()}>
                Филиалы
              </NavLink>
            </li>
          </ul>
      )}

      {isProfileRoleTypeTags(profile, [
        ROLE_ADMINISTRATOR,
        ROLE_DIRECTOR,
        ROLE_EMPLOYEE,
      ]) && (
        <ul className="Menu__list Menu__list_box">
          <li className="List__header">
            <div className="Header__text">Сайт</div>
          </li>
          <li className="List__link" style={{paddingTop: 12}}>
            <NavLink
              className={"Link__text"}
              to={"/site-shop-orders"}
              onClick={() => onChange()}
            >
              Заказы по рознице
            </NavLink>
          </li>
        </ul>
      )}

      {isProfileRoleTypeTags(profile, [
        ROLE_ADMINISTRATOR,
        ROLE_DIRECTOR,
        ROLE_EMPLOYEE,
      ]) && (
        <>
          {/*<ul className="Menu__list Menu__list_box">*/}
          {/*  <li className="List__link">*/}
          {/*    <NavLink*/}
          {/*      className={"Link__text"}*/}
          {/*      to={"/orders"}*/}
          {/*      onClick={() => onChange()}*/}
          {/*    >*/}
          {/*      Заказы*/}
          {/*    </NavLink>*/}
          {/*  </li>*/}
          {/*</ul>*/}

          <ul className="Menu__list Menu__list_box">
            <li className="List__header">
              <div className="Header__text">Номенклатура</div>
            </li>
            <li className="List__link" style={{paddingTop: 12}}>
              <NavLink
                className={"Link__text"}
                to={"/all-nomenclatures"}
                onClick={() => onChange()}
              >
                Вся номенклатура
              </NavLink>
            </li>
            <li className="List__link">
              <NavLink
                className={"Link__text"}
                to={"/nomenclatures"}
                onClick={() => onChange()}
              >
                Номенклатура
              </NavLink>
            </li>
          </ul>

          <ul className="Menu__list Menu__list_box">
            <li className="List__link">
              <NavLink
                className={"Link__text"}
                to={"/plan-warehouse"}
                onClick={() => onChange()}
              >
                План на сырьё
              </NavLink>
            </li>
          </ul>

          <ul className="Menu__list Menu__list_box">
            <li className="List__link">
              <NavLink
                className={"Link__text"}
                to={"/cows"}
                onClick={() => onChange()}
              >
                КРС
              </NavLink>
            </li>
          </ul>
        </>
      )}

      {(isProfileRoleTypeTags(profile, [
        ROLE_ADMINISTRATOR,
        ROLE_DIRECTOR,
      ]) || isProfileOpportunityTypeTags(profile, [
        OPPORTUNITY_KANBAN,
      ])) && (
        <ul className="Menu__list Menu__list_box">
          <li className="List__link">
            <NavLink
              className={"Link__text"}
              to={"/kanban"}
              onClick={() => onChange()}
            >
              Канбан
            </NavLink>
          </li>
        </ul>
      )}

      {(isProfileRoleTypeTags(profile, [
        ROLE_ADMINISTRATOR,
        ROLE_DIRECTOR,
        ROLE_EMPLOYEE,
      ]) || isProfileOpportunityTypeTags(profile, [
        OPPORTUNITY_HANDBOOK,
      ])) && (
        <ul className="Menu__list Menu__list_box">
          <li className="List__link">
            <NavLink
              className={"Link__text"}
              to={"/handbook"}
              onClick={() => onChange()}
            >
              Справочник
            </NavLink>
          </li>
        </ul>
      )}

      {isProfileRoleTypeTags(profile, [
        ROLE_ADMINISTRATOR,
        ROLE_DIRECTOR,
        ROLE_EMPLOYEE,
      ]) && (
        <ul className="Menu__list Menu__list_box">
          {/*<li className="List__link">*/}
          {/*  <NavLink className={"Link__text"} to={"/clients"} onClick={() => onChange()}>*/}
          {/*    Клиенты*/}
          {/*  </NavLink>*/}
          {/*</li>*/}
          <li className="List__link">
            <NavLink className={"Link__text"} to={"/employees"} onClick={() => onChange()}>
              Сотрудники
            </NavLink>
          </li>
          {isProfileRoleTypeTags(profile, [ROLE_ADMINISTRATOR]) && (
            <li className="List__link">
              <NavLink className={"Link__text"} to={"/accounts"} onClick={() => onChange()}>
                Аккаунты
              </NavLink>
            </li>
          )}
        </ul>
      )}

      {isProfileRoleTypeTags(profile, [
        ROLE_ADMINISTRATOR,
        ROLE_DIRECTOR,
        ROLE_EMPLOYEE,
      ]) && (
        <ul className="Menu__list Menu__list_box">
          <li className="List__header">
            <div className="Header__text">Печать</div>
          </li>
          <li className="List__link" style={{paddingTop: 12}}>
            <NavLink
              className={"Link__text"}
              to={"/printers"}
              onClick={() => onChange()}
            >
              Принтеры
            </NavLink>
          </li>
          <li className="List__link" style={{paddingTop: 12}}>
            <NavLink
              className={"Link__text"}
              to={"/printer-files"}
              onClick={() => onChange()}
            >
              Очередь печати
            </NavLink>
          </li>
        </ul>
      )}

      {isProfileRoleTypeTags(profile, [
        ROLE_ADMINISTRATOR,
        ROLE_DIRECTOR,
      ]) && (
        <ul className="Menu__list Menu__list_box">
          <li className="List__header">
            <div className="Header__text">Интеграция</div>
          </li>
          <li className="List__link" style={{paddingTop: 12}}>
            <NavLink
              className={"Link__text"}
              to={"/integration-alfabank"}
              onClick={() => onChange()}
            >
              Альфабанк
            </NavLink>
          </li>
        </ul>
      )}

      {(isProfileRoleTypeTags(profile, [
        ROLE_ADMINISTRATOR,
        ROLE_DIRECTOR,
      ]) || isProfileOpportunityTypeTags(profile, [
        OPPORTUNITY_TICKETS,
      ])) && (
        <ul className="Menu__list Menu__list_box">
          <li className="List__link">
            <NavLink
              className={"Link__text"}
              to={"/tickets"}
              onClick={() => onChange()}
            >
              Тикеты
              <div style={{
                fontSize: 12,
                opacity: .75
              }}>
                Задачи по улучшениям и ошибкам
              </div>
            </NavLink>
          </li>
        </ul>
      )}

      {isProfileRoleTypeTags(profile, [ROLE_DISPLAY]) && (
        <ul className="Menu__list">
          <li className="List__link" onClick={() => onChangeFullScreen()}>
            <Tooltip
              text={isFullScreen ? "В окне" : "На весь экран"}
              style={{cursor: "pointer"}}
            >
              {isFullScreen && (
                <Icon name={"custom-fullscreen-exit"} size={48} color={"#bbb"}/>
              )}
              {!isFullScreen && (
                <Icon name={"custom-fullscreen"} size={48} color={"#bbb"}/>
              )}
            </Tooltip>
          </li>
        </ul>
      )}
    </>
  );
}

export default MenuRouting;
